import { render, staticRenderFns } from "./SpotlightCarousel.vue?vue&type=template&id=7cc49177&scoped=true&"
import script from "./SpotlightCarousel.vue?vue&type=script&lang=js&"
export * from "./SpotlightCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightCarousel.vue?vue&type=style&index=0&id=7cc49177&prod&lang=scss&"
import style1 from "./SpotlightCarousel.vue?vue&type=style&index=1&id=7cc49177&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc49177",
  null
  
)

export default component.exports